function trimValue(value: string | undefined): string | null {
  if (!value) return null
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}

const appVersion = trimValue(__APP_VERSION__) ?? '0.0.0'
const buildSha = trimValue(__APP_BUILD_SHA__)
const buildRun = trimValue(__APP_BUILD_RUN__)

export function getBuildLines(): string[] {
  const lines = [`v${appVersion}`]

  if (buildSha && buildRun) {
    lines.push(`build #${buildRun} ${buildSha.slice(0, 7)}`)
  } else if (buildSha) {
    lines.push(`build ${buildSha.slice(0, 7)}`)
  } else if (import.meta.env.DEV) {
    lines.push('build local')
  }

  return lines
}
